export const KINDS = [
  { id: "story", es: "Un cuento", en: "A story", color: "bg-pink-300" },
  { id: "news", es: "Una noticia", en: "A news report", color: "bg-sky-300" },
  { id: "recipe", es: "Una receta o tutorial", en: "A recipe or how-to", color: "bg-lime-300" },
  { id: "ad", es: "Un anuncio", en: "An ad", color: "bg-yellow-300" },
];

export const STEPS = ["kind", "topic", "character", "place", "ending"];

export const STORY_TEXT = {
  es: {
    title: "¡De tu idea a tu video!",
    motto: "Escribe · Lee · Graba",
    intro: "¡Hola! Soy Lumi. Respóndeme 5 preguntas y yo convierto tu idea en un guion. Luego lo lees en el teleprompter y grabas tu voz, ¡como en la tele!",
    q: {
      kind: "¿Qué quieres crear?",
      topic: "¿De qué trata tu idea?",
      character: "¿Quién es el personaje principal?",
      place: "¿Dónde pasa?",
      ending: "¿Cómo termina o qué mensaje quieres dejar?",
    },
    ph: {
      topic: "Ej: un perrito que quiere aprender a nadar",
      character: "Ej: Toby, un perrito valiente",
      place: "Ej: en una playa con muchos colores",
      ending: "Ej: aprende que practicar ayuda",
    },
    step: "Paso", of: "de", next: "Siguiente", back: "Atrás", make: "¡Lumi, escribe mi guion!",
    writing: "Lumi está escribiendo...", fail: "Lumi no pudo escribir el guion, intenta otra vez",
    login: "Entra para crear tu guion", script: "Tu guion", edit: "Puedes cambiar las palabras que quieras.",
    cover: "Crear portada con IA", coverAgain: "Crear otra portada", coverLoading: "Dibujando la portada...", coverFail: "No se pudo crear la portada",
    toPrompter: "Leer en el teleprompter", restart: "Crear otro guion", notSaved: "Ojo: el guion no se guarda. ¡Grábalo antes de salir!",
    imgErr: "No se pudo crear la portada",
  },
  en: {
    title: "From your idea to your video!",
    motto: "Write · Read · Record",
    intro: "Hi! I'm Lumi. Answer 5 questions and I'll turn your idea into a script. Then read it on the teleprompter and record your voice, like on TV!",
    q: {
      kind: "What do you want to create?",
      topic: "What is your idea about?",
      character: "Who is the main character?",
      place: "Where does it happen?",
      ending: "How does it end, or what message do you want to share?",
    },
    ph: {
      topic: "E.g. a puppy who wants to learn to swim",
      character: "E.g. Toby, a brave puppy",
      place: "E.g. on a colorful beach",
      ending: "E.g. he learns that practice helps",
    },
    step: "Step", of: "of", next: "Next", back: "Back", make: "Lumi, write my script!",
    writing: "Lumi is writing...", fail: "Lumi couldn't write the script, try again",
    login: "Sign in to create your script", script: "Your script", edit: "You can change any words you like.",
    cover: "Create AI cover", coverAgain: "Create another cover", coverLoading: "Drawing the cover...", coverFail: "Couldn't create the cover",
    toPrompter: "Read on the teleprompter", restart: "Create another script", notSaved: "Heads up: the script isn't saved. Record it before you leave!",
    imgErr: "Couldn't create the cover",
  },
};

export const PROMPTER_TEXT = {
  es: {
    title: "Teleprompter", play: "Empezar", pause: "Pausa", reset: "Al inicio", speed: "Velocidad", size: "Tamaño",
    rec: "Grabar mi voz", stop: "Parar grabación", recording: "Grabando...", listen: "Escucha tu grabación",
    download: "Descargar audio", again: "Grabar otra vez", micErr: "No pudimos usar el micrófono. Pide a un adulto que dé permiso en el navegador.",
    back: "Volver al guion", tip: "Mira la línea amarilla y lee despacio.",
  },
  en: {
    title: "Teleprompter", play: "Start", pause: "Pause", reset: "To start", speed: "Speed", size: "Size",
    rec: "Record my voice", stop: "Stop recording", recording: "Recording...", listen: "Listen to your recording",
    download: "Download audio", again: "Record again", micErr: "We couldn't use the microphone. Ask an adult to allow it in the browser.",
    back: "Back to script", tip: "Look at the yellow line and read slowly.",
  },
};
